@if (loading) {
  <p-progress-spinner ariaLabel="loading" class="spinner" />
}

<div class="skill-table">
  <div class="filter-container gap-3 grid grid-nogutter mb-3">
    <div class="col-fixed">
      <p-multiSelect
        (onChange)="filterColumnsByGroup()"
        [(ngModel)]="selectedSkillGroup"
        [options]="groups"
        placeholder="Group">
        <ng-template #item let-option>
          <div class="inline-block align-middle">
            <span class="ml-1 mt-1">{{ option }}</span>
          </div>
        </ng-template>
      </p-multiSelect>
    </div>

    <div class="col-fixed">
      <p-multiSelect
        (onChange)="filterColumnsByCategory()"
        [(ngModel)]="selectedSkills"
        [options]="skillsCategory"
        placeholder="Skill">
        <ng-template #item let-option>
          <div class="inline-block align-middle">
            <span class="ml-1 mt-1">{{ option }}</span>
          </div>
        </ng-template>
      </p-multiSelect>
    </div>

    <div class="col-fixed">
      <p-multiSelect
        (onChange)="applyFilters()"
        [(ngModel)]="selectedLevels"
        [options]="levels"
        placeholder="Data"
        [filter]="false"
        [showToggleAll]="false"
        [disabled]="!selectedSkills.length">
        <ng-template #item let-option>
          <div class="inline-block align-middle">
            <span class="ml-1 mt-1">{{ option }}</span>
          </div>
        </ng-template>
      </p-multiSelect>
    </div>

    <div class="col-fixed">
      <p-multiSelect
        (onChange)="applyFilters()"
        [(ngModel)]="selectedTeams"
        [options]="teams"
        placeholder="Team">
        <ng-template #item let-option>
          <div class="inline-block align-middle">
            <span class="ml-1 mt-1">{{ option }}</span>
          </div>
        </ng-template>
      </p-multiSelect>
    </div>
  </div>

  <p-table
    [columns]="filteredSkills"
    [scrollable]="true"
    [value]="filteredData"
    [autoLayout]="true"
    [tableStyle]="{ 'z-index': '0', 'position': 'relative' }"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th alignFrozen="left" pFrozenColumn pSortableColumn="team"
            style="min-width: 268px; max-width: 268px">People
          <p-sortIcon field="team" />
        </th>

        @for (col of filteredSkills; track col) {
          <th style="min-width: 168px; max-width: 168px">
            {{ col }}
          </th>
        }
      </tr>
      <tr class="table__subheader">
        <th alignFrozen="left" pFrozenColumn style="min-width: 268px; max-width: 268px">Categories
          <i
            class="pi pi-info-circle ml-2"

            style="color: slateblue"
            pTooltip="Prima lettera:
              C = &quot;conosco&quot;, possiedo questa skill, ho esperienza professionalmente utile con questa tecnologia, ci so già fare le cose che di solito dobbiamo fare nei progetti su cui lavoriamo (report, CRUD, APIs, ...)
              N = &quot;non conosco&quot;, non possiedo questa skill, non ho mai visto né usato seriamente questa tecnologia, se dovessi usare questa skill non sarei autonomo da subito
              X  = &quot;non lo so&quot;, non riesco a posizionarmi o a decidere, o non voglio dirlo [usare per invocare una conversazione con il team]

              Seconda lettera:
              M = &quot;mi piace&quot;, sono contento di usarla, vorrei usarla, mi incuriosisce
              N = &quot;non mi piace&quot;, non mi attira, mi ha stancato, non mi incuriosisce
              X = &quot;non lo so&quot;, non ho un'opinione a riguardo, non ho abbastanza informazioni per decidere

              E' possibile eventualmente aggiungere in coda una terza lettera (non è obbligatorio):
              T = &quot;teacher&quot;, sono disponibile a fornire aiuto o consulenza su quell'argomento
              S = &quot;student&quot;, mi piacerebbe imparare, saperne di più, approfondire"
          ></i></th>

        @for (col of filteredSkills; track col) {
          <th style="min-width: 168px; max-width: 168px">
            <div class="cell-spacing">
              <div tooltipPosition="top" pTooltip="Conoscenze">C</div>
              <div tooltipPosition="top" pTooltip="Interesse">I</div>
              <div tooltipPosition="top" pTooltip="Formazione">F</div>
            </div>
          </th>
        }
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-columns="columns" let-rowData>
      <tr [ngClass]="{'highlight-row': rowData['acronym']?.toLowerCase() === myUsername?.toLowerCase()}">
        <td
          pFrozenColumn
          style="min-width: 268px; max-width: 268px"
          [ngClass]="{'highlight-row': rowData['acronym']?.toLowerCase() === myUsername?.toLowerCase()}"
        >
          <div class="align-items-center flex gap-3 hstack">
            <div
              class="user-propic"
              [ngStyle]="{  'background-image': rowData['image']    ? 'url(data:image/png;base64,' + rowData['image'] + ')'    : 'none'}">
              <span *ngIf="!rowData['image']">
                {{ getInitials(rowData['username']) }}
              </span>
            </div>

            <div class="hstack">
              <div class="cell-username" (click)="openUserSMDetail(rowData['acronym'])">{{ rowData['username'] }}</div>
              <div class="cell-team">{{ rowData['team'] }}</div>
            </div>
          </div>
        </td>

        @for (col of columns; track col) {
          <td class="no-wrapped" style="min-width: 168px; max-width: 168px">
            <div class="cell-spacing">

              <ng-container *ngIf="rowData.skills?.[col] as skill">
                <div class="p-badge__wrap">
                  <div class="p-badge p-badge-circle" [ngClass]="getColor('knowledge', skill.knowledge)">
                    <i tooltipPosition="top" pTooltip="{{ getTooltipLabel('knowledge', skill.knowledge) }}"
                       class="fa-solid" [ngClass]="getIcon('knowledge', skill.knowledge)"></i>
                  </div>
                </div>

                <div class="p-badge__wrap">
                  <div class="p-badge p-badge-circle" [ngClass]="getColor('like', skill.like)">
                    <i tooltipPosition="top" pTooltip="{{ getTooltipLabel('like', skill.like) }}" class="fa-solid"
                       [ngClass]="getIcon('like', skill.like)"></i>
                  </div>
                </div>

                <div class="p-badge__wrap">
                  <div class="p-badge p-badge-circle"
                       [ngClass]="getColor('teaching_learning', skill.teaching_learning)">
                    <i tooltipPosition="top"
                       pTooltip="{{ getTooltipLabel('teaching_learning', skill.teaching_learning) }}" class="fa-solid"
                       [ngClass]="getIcon('teaching_learning', skill.teaching_learning)"></i>
                  </div>
                </div>
              </ng-container>

            </div>
          </td>
        }

      </tr>
    </ng-template>
  </p-table>
</div>
